var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreentick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.404785,
    width: 27.99,
    height: 27.99,
    rx: 8.75,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9952 20.2194C17.2145 20.2194 19.8243 17.6096 19.8243 14.3902C19.8243 11.1708 17.2145 8.56104 13.9952 8.56104C10.7758 8.56104 8.16602 11.1708 8.16602 14.3902C8.16602 17.6096 10.7758 20.2194 13.9952 20.2194Z",
    stroke: "#16A34A",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2461 14.3902L13.4122 15.5563L15.7444 13.2241",
    stroke: "#16A34A",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/greentick.49471621e9d10d02302ffc27c411ec3f.svg";
export { ForwardRef as ReactComponent };